<ng-container>
	<!-- Search bar -->
	<section>
		<div class="analysis-options">
			<!-- Search bar -->
			<div class="search-group clearfix">
				<div class="search-input pull-left">
					<input #searchText (keyup)="filterModels(searchText.value)" class="search" [placeholder]="'Search by keyword' | dcr : 'SEARCH_PLACEHOLDER'" />
					<icon type="search"></icon>
				</div>
			</div>
		</div>
	</section>

	<!-- Pills for selected models and portfolios -->
	<section *ngIf="pillsFilterType && !hidePills">
		<mp-pills [pillsFilterType]="pillsFilterType" [(selectedItems)]="selectedModelPortfolios"></mp-pills>
	</section>

	<!-- Families with BlackRock models table -->
	<section class="grid">
		<mp-families-table
			[families]="filteredFamilies"
			[default]="false"
			[mode]="mode"
			[pillsFilterType]="pillsFilterType"
			[showCheckboxes]="showCheckboxes"
			[allowMultiple]="allowMultiple"
			[(selectedModelPortfolios)]="selectedModelPortfolios"
			[maxLimit]="maxLimit"
			[arrowLeft]="arrowLeft"
			[useDasPortfolioId]="useDasPortfolioId"
			(onModelSelected)="onModelPortfolioSelected()"
		></mp-families-table>
	</section>
</ng-container>
